var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"le-card-container",style:({
  width: _vm.width,
  minHeight:_vm.height,
  background: _vm.background
}),on:{"click":function($event){return _vm.$emit('cardClick')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }